//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { getIdsOfAlphabetizedGalleries } from '@galleries/selectors/getIdsOfAlphabetizedGalleries';
import { ICuralateStore } from '@models/AppState';
import { isDefined } from '@utils/filterPredicates';
import { Normalized } from '@utils/normalize';

export const getAllAlphabetizedGalleries = createSelector(
  getIdsOfAlphabetizedGalleries,
  (state: ICuralateStore) => state.galleries.data.galleries,
  (alphabetizedIds, galleries) =>
    alphabetizedIds
      .map((containerId) => Normalized.getById(galleries, containerId))
      .filter(isDefined),
);
